// extracted by mini-css-extract-plugin
module.exports = {"tableSelectionWrapper":"UGjGy"};